module.exports = __webpack_public_path__ + "static/t_325_718-2747f4c276eaa45938d082e36e2f070d.png";